// Libraries
var React = require('react');

// Components
var OptaWidget = require('../../MDC/OptaWidget/OptaWidget');

// Styles
require('./TeamSeasonStats.scss');

class TeamSeasonStatsModule extends React.Component {
    
	render() {
        return (
            <div className="TeamSeasonStats">
                <OptaWidget language={this.props.data.language} timezone={this.props.data.timezone} subscriptionId={this.props.data.subscriptionId} properties={this.props.data.properties}/>
            </div>)
    }
}
    
module.exports = TeamSeasonStatsModule;


// WEBPACK FOOTER //
// ./src/components/Team/TeamSeasonStats/TeamSeasonStatsModule.js